/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable */
import store from '@/store';
import { Toast } from '@hb/coffee';
import { NativeSignVo } from '@/api/native/types';
import platform from '@/shared/utils/platform';
import { versionCompare } from '../../shared/utils/versionCompare';
import { ubtButton } from '@/shared/utils/ubt';
import { landData } from '@/shared/utils/landData';

const HBridge = import('@hb/hbridge');
const PleaseUpgrade = '请升级app到最新版本以使用该功能';


// 平台支付收银台（该方法目前已应用至臻有钱）
// 哈啰出行APP，支付宝小程序
export const alipayPay = async (options: Dictionary): Promise<void> => {
  if (!platform.isAlipayMini) {
    if (versionCompare(store.state.base.deviceInfo.appVersion, '5.23.0') < 0) {
      Toast(PleaseUpgrade);
      return Promise.reject(new Error(PleaseUpgrade));
    }
  }
  return (await HBridge).Native.pay(options);
};

// 支付宝免密签约（该方法目前已应用至臻有钱）
// 哈啰出行APP，支付宝小程序；支支付宝小程序；NativeSignVo
export const signWithoutPasswordContract = async (
  options: NativeSignVo,
): Promise<void> => {
  if (!platform.isAlipayMini) {
    if (versionCompare(store.state.base.deviceInfo.appVersion, '5.37.0') < 0) {
      Toast(PleaseUpgrade);
      return Promise.reject(new Error(PleaseUpgrade));
    }
  }
  return (await HBridge).Native.signWithoutPasswordContract(options);
};

// 支付宝签约-小程序环境-支付
export const payByTradeAlipayMini = async (params: string) => (await HBridge).Native.callNative({
  method: 'payByTradeNO',
  params,
  timeout: false,
});

// 支付宝免密签约-小程序
export const paySignCenterAlipay = async (params: string) => (await HBridge).Native.paySignCenter(params)

// 支付宝小程序中获取授权弹窗
export const getAuthUserInfo = async (params: {}) => {
  ubtButton('Bootstrap', 'finance_alipay_dialog', 'source', landData.getSouce())
  return (await HBridge).Native.callNative({
    method: 'authLogin',
    classMap: 'AuthStore',
    params
  })
}

// 校验token
export const cehckUserToken = async (params: {}) => (await HBridge).Native.callNative({
  method: 'insureLoginState',
  classMap: 'AuthStore',
  params
})
